import { Box, Button, Flex, Text, useMediaQuery } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

import FreePlanImage from 'components/Icons/FreePlan';
import RocketLaunch from 'components/Icons/RocketLaunch';

const UPGRADE_BOX_BG = '#F0EDF8';
const FEATURE_ICON_BG = '#6B5FC6';

const UserUpgradeModalNew = () => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  const features = [
    'Invite your team members to share models,',
    'Engage with insights and collaborate',
  ];

  return (
    <Flex width='100%' height='100%' flexDir='column'>
      <Box mb='4'>
        <Text color='#212121' fontSize={isMobile ? '18px' : '20px'} fontWeight='bold' mb='2'>
          Team
        </Text>
        <Text color='#787878' fontSize='14px' fontFamily='regular_roboto'>
          Manage your Blox Team
        </Text>
      </Box>

      <Flex
        bg={UPGRADE_BOX_BG}
        borderRadius='12px'
        p={isMobile ? '5' : '6'}
        flexDir={isMobile ? 'column' : 'row'}
        // alignItems={isMobile ? 'stretch' : 'center'}
        gap={isMobile ? '4' : '6'}
        flex='1'
        minH='0'
        maxH='300px'
      >
        <Flex flexDir='column' flex='1' minW='0'>
          <Text fontSize={isMobile ? 'lg' : 'xl'} color='#212121' fontWeight='bold' mb='4'>
            Upgrade your Blox subscription to unlock teams...
          </Text>
          <Flex flexDir='column' gap='3' mb='6'>
            {features.map((feature, index) => (
              <Flex key={index} alignItems='center' gap='3'>
                <Flex
                  bg={FEATURE_ICON_BG}
                  borderRadius='full'
                  w='6'
                  h='6'
                  minW='6'
                  minH='6'
                  alignItems='center'
                  justifyContent='center'
                >
                  <CheckIcon color='white' boxSize={3} />
                </Flex>
                <Text fontSize='md' color='#212121' fontWeight='400'>
                  {feature}
                </Text>
              </Flex>
            ))}
          </Flex>
          <Button
            bgColor='#6B5FC6'
            color='white'
            borderRadius='10px'
            leftIcon={<RocketLaunch height={5} width={5} color='white' />}
            paddingInline='4'
            paddingY='2'
            width='100%'
            fontWeight='600'
            fontSize='sm'
            _hover={{ bgColor: '#5a4fb5' }}
            onClick={() => {
              window.open('https://www.blox.so/pricing', '_blank');
            }}
          >
            View Paid Plans
          </Button>
        </Flex>
        {!isMobile && (
          <Box flexShrink={0} ml='2'>
            <FreePlanImage height='200px' width='200px' />
          </Box>
        )}
      </Flex>
    </Flex>
  );
};

export default UserUpgradeModalNew;
